/**
 * CharacterPanel - 故事角色展示面板
 */
import { User, Crown, HelpCircle } from 'lucide-react';
import { EditorCharacter } from '../../../store/useDIYEditorStore';

interface CharacterPanelProps {
  characters: EditorCharacter[];
}

export default function CharacterPanel({ characters }: CharacterPanelProps) {
  if (characters.length === 0) {
    return (
      <div className="bg-slate-50 rounded-xl p-4 text-center">
        <p className="text-xs text-slate-400">暂无角色信息</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {characters.map((char) => (
        <div
          key={char.id}
          className="bg-white rounded-xl border border-slate-200 p-3 flex items-start gap-3"
        >
          {/* 头像/图标 */}
          <div className="shrink-0">
            {char.photoUrl ? (
              <img
                src={char.photoUrl}
                alt={char.name}
                className="w-10 h-10 rounded-full object-cover border border-slate-200"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center">
                {char.type === 'protagonist' ? (
                  <Crown className="w-5 h-5 text-indigo-500" />
                ) : (
                  <User className="w-5 h-5 text-slate-400" />
                )}
              </div>
            )}
          </div>

          {/* 信息 */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1.5 mb-0.5">
              <span className="text-sm font-semibold text-slate-800 truncate">{char.name}</span>
              {char.type === 'protagonist' && (
                <span className="text-[10px] bg-indigo-100 text-indigo-600 px-1.5 py-0.5 rounded-full font-medium">
                  主角
                </span>
              )}
              {char.type === 'supporting' && char.characterType && (
                <span className="text-[10px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded-full font-medium">
                  {char.characterType === 'human' ? '人物' : '动物'}
                </span>
              )}
            </div>
            <p className="text-xs text-slate-500 line-clamp-2">{char.description || '暂无描述'}</p>
          </div>
        </div>
      ))}

      {/* 提示 */}
      <div className="flex items-start gap-1.5 mt-2 px-1">
        <HelpCircle className="w-3.5 h-3.5 text-slate-400 shrink-0 mt-0.5" />
        <p className="text-[11px] text-slate-400">
          角色描述将用于 AI 插图的一致性约束
        </p>
      </div>
    </div>
  );
}
